// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_bt-2";
export var aiChatCartContainerExit = "_bt-4";
export var aiChatContainerLarge = "_bt-0";
export var aiChatContainerSmall = "_bt-1";
export var aiChatIcon = "_bt-6";
export var slideInFromRight = "_bt-3";
export var slideOutToRight = "_bt-5";